// extracted by mini-css-extract-plugin
export default {"WidgetPair":"WidgetPair_WidgetPair__yv2EV"};